// extracted by mini-css-extract-plugin
export default {"purchase":"Purchase_purchase__nqTgq"};